import { combineReducers } from 'redux';
import {
  FETCH_COUPONS_REQUEST,
  FETCH_COUPONS_SUCCESS,
  FETCH_COUPONS_FAILURE,
  FETCH_COUPON_BY_ID_REQUEST,
  FETCH_COUPON_BY_ID_SUCCESS,
  FETCH_COUPON_BY_ID_FAILURE,
  COUPON_SELECTED_CLEAR,
} from '../../constants/ActionTypes';

const list = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_COUPONS_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_COUPONS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
        paging: action.data.paging,
      };
    case FETCH_COUPONS_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    default:
      return state;
  }
};

const selected = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_COUPON_BY_ID_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_COUPON_BY_ID_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
      };
    case FETCH_COUPON_BY_ID_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    case COUPON_SELECTED_CLEAR:
      return { data: {}, isFetching: false, errorMessage: null };
    default:
      return state;
  }
};

const coupons = combineReducers({
  list,
  selected,
});

export default coupons;
